import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  fill: currentColor;\n\n  &:not(:only-of-type) {\n    display: none; /* default icon should be hidden and active shown (only if active exits) */\n  }\n\n  /* SHOW active icon when it's active (it's a second SVG node) */\n  &:nth-of-type(2) {\n    display: block;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n          &::after {\n            display: none;\n          }\n        "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n          /* stylelint-disable-next-line no-duplicate-selectors */\n          &:focus {\n            background-color: ", ";\n            color: ", ";\n          }\n\n          &:hover {\n            background-color: ", ";\n            color: ", ";\n            text-decoration: none;\n          }\n        "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      border-radius: ", "px;\n      min-height: ", ";\n      padding: ", " ", ";\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  box-sizing: border-box;\n  color: ", ";\n  cursor: ", ";\n  display: flex;\n  font-size: ", "px;\n  font-weight: inherit;\n  line-height: 1;\n  padding: ", "px ", "px;\n  text-align: left;\n  text-decoration: none;\n  transition: background-color ", ", color ", ";\n  white-space: nowrap;\n  width: 100%;\n\n  &:hover,\n  &:focus {\n    text-decoration: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  ", "\n\n  /* hide hover/focus states if not clickable */\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  color: ", ";\n\n  &:hover {\n    ", "\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n      margin-right: ", ";\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fill: ", ";\n  margin-right: ", ";\n  transition: fill ", ";\n\n  ", "\n\n  /*\n    * Second SVG node is active icon - activeIconName\n    * By default, it should be hidden and enabled only when active styles applied (see activeStyle)\n  */\n  &:nth-of-type(2) {\n    display: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';
import { rgba } from 'polished';
import { property, color, size, typography } from '@scp/ui-shared/theme/variables';
import { baselineToPx, baselineToRem } from '@scp/ui-shared/theme/utils';

var getTextColor = function getTextColor(_ref) {
  var darkBackground = _ref.darkBackground;
  if (darkBackground) return color.menuInactiveOnDark;
  return color.menuInactive;
};

var getBackgroundHoverColor = function getBackgroundHoverColor(_ref2) {
  var darkBackground = _ref2.darkBackground;
  if (darkBackground) return rgba(color.palette.white, 0.1);
  return color.backgroundSecondary;
};

export var itemIconBase = css(_templateObject(), function (props) {
  return props.color ? props.color : 'currentColor';
}, baselineToPx(2), property.transition, function (props) {
  return props.$roundedStyle && css(_templateObject2(), baselineToPx(2));
});
export var activeStyleBase = function activeStyleBase(props) {
  return css(_templateObject3(), props.darkBackground ? 'transparent' : color.active, props.darkBackground ? color.menuItemActive : color.menuItemSecondaryActive, props.darkBackground && css(_templateObject4(), getBackgroundHoverColor(props)));
};
export var itemBase = css(_templateObject5(), getTextColor, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.large ? 16 : typography.defaultFontSize;
}, function (props) {
  return props.large ? 8 : 4;
}, size.gutterSmall, property.transition, property.transition, function (props) {
  return props.roundedStyle && css(_templateObject6(), property.borderRadius, baselineToRem(9), baselineToPx(1), baselineToPx(2));
}, function (props) {
  return !props.nonFocusable ? css(_templateObject7(), props.navigatingByKeyboard ? getBackgroundHoverColor(props) : 'transparent', getTextColor, getBackgroundHoverColor, getTextColor) : css(_templateObject8());
});
export var iconBase = css(_templateObject9());